/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {HandleQualifiers} from './HandleQualifiers';
import {
  HandleQualifiersFromJSON,
  HandleQualifiersFromJSONTyped,
  HandleQualifiersToJSON
} from './HandleQualifiers';
import type {LogicalElementData} from './LogicalElementData';
import {
  LogicalElementDataFromJSON,
  LogicalElementDataFromJSONTyped,
  LogicalElementDataToJSON
} from './LogicalElementData';
import type {LogicalElementItem} from './LogicalElementItem';
import {
  LogicalElementItemFromJSON,
  LogicalElementItemFromJSONTyped,
  LogicalElementItemToJSON
} from './LogicalElementItem';
import type {Style} from './Style';
import {StyleFromJSON, StyleFromJSONTyped, StyleToJSON} from './Style';
import type {ElementData} from './ElementData';
import {ElementDataFromJSON, ElementDataFromJSONTyped, ElementDataToJSON} from './ElementData';
import type {WorkZoneElementData} from './WorkZoneElementData';
import {
  WorkZoneElementDataFromJSON,
  WorkZoneElementDataFromJSONTyped,
  WorkZoneElementDataToJSON
} from './WorkZoneElementData';

/**
 *
 * @export
 * @interface Data3
 */
export interface Data3 {
  /**
   *
   * @type {string}
   * @memberof Data3
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof Data3
   */
  templateCode?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof Data3
   */
  isSubElement?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Data3
   */
  isNotElement?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Data3
   */
  isRotate?: boolean;
  /**
   *
   * @type {Array<LogicalElementItem>}
   * @memberof Data3
   */
  logicalElements?: Array<LogicalElementItem>;
  /**
   *
   * @type {Style}
   * @memberof Data3
   */
  style?: Style;
  /**
   *
   * @type {Array<HandleQualifiers>}
   * @memberof Data3
   */
  handleQualifiers?: Array<HandleQualifiers> | null;
}

/**
 * Check if a given object implements the Data3 interface.
 */
export function instanceOfData3(value: object): value is Data3 {
  return true;
}

export function Data3FromJSON(json: any): Data3 {
  return Data3FromJSONTyped(json, false);
}

export function Data3FromJSONTyped(json: any, ignoreDiscriminator: boolean): Data3 {
  if (json == null) {
    return json;
  }
  return {
    title: json['title'] == null ? undefined : json['title'],
    templateCode: json['templateCode'] == null ? undefined : json['templateCode'],
    isSubElement: json['isSubElement'] == null ? undefined : json['isSubElement'],
    isNotElement: json['isNotElement'] == null ? undefined : json['isNotElement'],
    isRotate: json['isRotate'] == null ? undefined : json['isRotate'],
    logicalElements:
      json['logicalElements'] == null
        ? undefined
        : (json['logicalElements'] as Array<any>).map(LogicalElementItemFromJSON),
    style: json['style'] == null ? undefined : StyleFromJSON(json['style']),
    handleQualifiers:
      json['handleQualifiers'] == null
        ? undefined
        : (json['handleQualifiers'] as Array<any>).map(HandleQualifiersFromJSON)
  };
}

export function Data3ToJSON(value?: Data3 | null): any {
  if (value == null) {
    return value;
  }
  return {
    title: value['title'],
    templateCode: value['templateCode'],
    isSubElement: value['isSubElement'],
    isNotElement: value['isNotElement'],
    isRotate: value['isRotate'],
    logicalElements:
      value['logicalElements'] == null
        ? undefined
        : (value['logicalElements'] as Array<any>).map(LogicalElementItemToJSON),
    style: StyleToJSON(value['style']),
    handleQualifiers:
      value['handleQualifiers'] == null
        ? undefined
        : (value['handleQualifiers'] as Array<any>).map(HandleQualifiersToJSON)
  };
}
